import React from 'react';
import Text from 'components/Text';
import EmailForm from 'components/EmailForm';
import GearSubset from 'components/GearSubset';
import MobileGearSubset from 'components/MobileGearSubset';
import v from 'vudu';
import { styles as s, colors, classes as c, format as f, breakpoints } from 'stylesheet';
import { COUNTUP_OPTIONS_NO_PREF, COUNTUP_OPTIONS } from 'constants/countUp';
import copy from 'constants/copy';
import data from 'constants/data';
import Down from 'components/svgs/Down';
import { TweenLite } from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import PlayButton from 'components/PlayButton';
import Waypoint from 'react-waypoint';
import MoneyCounter from 'components/MoneyCounter';
import BorderStar from 'components/BorderStar';

import adobeSponsor from 'assets/homeView/sponsored.svg';
import headerImage from 'assets/header.jpg';
import frameRippleImage from 'assets/homeView/frame-ripples.png';
import adobeRippleImage from 'assets/homeView/adobe-ripples.png';
import borisfxImage from 'assets/homeView/logo-borisfx.png';
import musicbedImage from 'assets/homeView/logo-musicbed.png';
import redgiantImage from 'assets/homeView/logo-redgiant.png';
import videocopilotImage from 'assets/homeView/logo-videocopilot.png';
import tubes1 from 'assets/homeView/tubes-1.png';
import tubes2 from 'assets/homeView/tubes-2.png';
import facebookIcon from 'assets/homeView/icon-facebook.svg';
import twitterIcon from 'assets/homeView/icon-twitter.svg';
import dribbleIcon from 'assets/homeView/icon-dribble.svg';

import Frame from 'components/svgs/Frame';

const localClasses = v({
  homeView: {
    height: '100%'
  },
  headerModule: {
    '@composes': [s.px1, s.relative, s.pt4],
    height: '100vh',
    backgroundColor: 'transparent',
    backgroundImage: `url(${headerImage})`,
    backgroundSize: 'cover',
    backgroundPosition: '70% 100%'
  },
  gradient: {
    backgroundImage: 'radial-gradient(circle at 80%, transparent 0, black 65%)',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    position: 'absolute',
    pointerEvents: 'none'
  },
  headerModuleCopy: {
    '@composes': [s.pb4],
    [breakpoints.lg]: {
      '@composes': [s.px3, s.mb3, s.pb0]
    }
  },
  sponsorLogo: {
    position: 'absolute',
    bottom: '50px',
    right: '10%',
    opacity: '0.5'
  },
  nextPanelCTA: {
    '@composes': [s.center, s.absolute, s.l0, s.mb3],
    bottom: '30px',
    width: '100%',
    cursor: 'pointer',
    'svg': { transition: '150ms' },
    ':hover': {
      'svg': {
        transform: 'translateY(4px)'
      }
    },
    [breakpoints.lg]: {
      bottom: '20px',
    }
  },
  nextPanelCTAText: {
    '@composes': [s.mb1]
  },
  gearSubsetsModule: {
    '@composes': [s.px3, s.pt4],
    overflow: 'hidden'
  },
  headerModuleContent: {
    '@composes': [s.pt4],
    zIndex: 1,
    position: 'relative',
    textAlign: 'center',
    margin: 'auto',
    'aside': { display: 'none' },
    [breakpoints.lg]: {
      '@composes': [s.verticalCenter],
      display: 'flex',
      textAlign: 'left',
      'aside': { display: 'flex'}
    },
  },
  extraSection: {
    '@composes': [s.py3],
    paddingRight: '0px',
    paddingLeft: '0px',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
    ':last-of-type': {
      borderBottom: 'none'
    }
  },
  extraSummary: {
    '@composes': [s.mb2, s.center],
    [breakpoints.sm]: {
      '@composes': [
        s.mb0,
        s.col3,
        s.center,
        s.left,
        s.pr2,
      ]
    },
    [breakpoints.md]: {
      '@composes': [
        s.pr4,
      ]
    }
  },
  extraImage: {
    maxWidth: '180px',
    [breakpoints.sm]: {
      width: '100%'
    }
  },
  extraDetails: {
    [breakpoints.sm]: {
      '@composes': [
        s.col9,
        s.left
      ]
    }
  },
  finalBeat: {
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    height: '80vh',
    [breakpoints.lg]: {
      height: '80vh'
    }
  },
  float: {
    animation: 'float 10s ease-in-out infinite',
    '@keyframes float': {
      '0%': {
        transform: 'translate(0px, 0px)',
      },
      '50%': {
        transform: 'translate(-5px, -20px)',
      },
      '100%': {
        transform: 'translate(0px, 0px)',
      }
    }
  },
  tubes1: {
    '@keyframes tubeSpin1': {
      'to': { transform: 'rotate(-360deg)' }
    },
    animation: 'tubeSpin1 20s linear infinite',
    position: 'absolute',
    maxWidth: '120px',
    left: '-150px',
    bottom: '10px',
    [breakpoints.lg]: {
      maxWidth: '300px',
    }
  },
  tubes2: {
    '@keyframes tubeSpin2': {
      'to': { transform: 'rotate(-360deg)' }
    },
    animation: 'tubeSpin2 24s linear infinite',
    position: 'absolute',
    maxWidth: '180px',
    right: '-150px',
    top: '80px',
    [breakpoints.lg]: {
      maxWidth: '320px',
    }
  },
  massive: {
    display: 'inline',
    [breakpoints.lg]: {
      fontSize: '160px',
    }
  },
  footer: {
    backgroundImage: 'linear-gradient(226deg, #5D1F5A 0%, #231E4A 100%)'
  },
  footerEnd: {
    '@composes': [s.flex],
    justifyContent: 'space-between'
  },
  footerSet: {
    display: 'flex',
    alignItems: 'center'
  },
  mainSoftware: {
    paddingBottom: '40px',
    [breakpoints.lg]: {
      paddingBottom: '0px'
    }
  },
  sub: {
    fontSize: '16px',
    lineHeight: '22px',
    [breakpoints.md]: {
      fontSize: '22px',
      lineHeight: '31px'
    }
  }
});

const renderGearSets = (sets, setModal, isMobile) => {
  return sets.map((set, index) => {
    if (isMobile) return <MobileGearSubset key={index} set={set} setModal={setModal} />
    return <GearSubset key={index} set={set} setModal={setModal} />
  });
}

const scrollToPrize = () => {
  TweenLite.to(window, 0.5, { scrollTo: '#gearsets' });
}

export default props => (
  <section className={localClasses.homeView}>
    <article className={localClasses.headerModule}>
      <div className={f(localClasses.headerModuleContent, c.row, c.clearfix)}>
        <div className={f(c.col12, c.lgCol6, c.left)}>
          <div className={localClasses.headerModuleCopy}>
            <Text classes={c.inlineBlock} variant={'heroHeadline'}>{"Win the $62,000 Frame.io Dreamstation"}</Text>
            <Text variant={'subheadlineLarge'} classes={localClasses.sub}>{copy.homeView.subheading}</Text>
          </div>
          <EmailForm position={'hero'} />
        </div>
        <aside className={f(c.col12, c.lgCol6, c.left, c.flex, c.alignCenter, c.justifyCenter)}>
          <PlayButton setVideoOverlay={props.setVideoOverlay} />
        </aside>
      </div>
      <Waypoint
        onEnter={() => props.setStickyNavVisiblity(false)}
        onLeave={() => props.setStickyNavVisiblity(true)}
      />
      <div className={localClasses.nextPanelCTA} onClick={scrollToPrize}>
        <Text variant={'smallTracked'} classes={localClasses.nextPanelCTAText}>{copy.homeView.nextPanelCTA}</Text>
        <Down />
      </div>
      <img className={localClasses.sponsorLogo} src={adobeSponsor} />
      <div className={localClasses.gradient}></div>
    </article>

    <article id='gearsets' className={localClasses.gearSubsetsModule}></article>
    {renderGearSets(data.gearSubsets, props.setModal, props.isMobile)}

    {/* Software Section */}
    <div className={f(c.row, c.clearfix, c.pb5, c.pt4)}>
      <div className={f(c.col12, c.center)}>
        <Text variant={'headline'}>{copy.homeView.infoHeading}</Text>
        <Text variant={'p'}>{copy.homeView.infoSubheading1}</Text>
      </div>
    </div>

    {/* Frame x Adobe */}
    <div className={f(c.row, c.clearfix, c.pb5)}>
      <div className={f(c.col12, c.mdCol10, c.mxAuto)}>
        <div className={f(c.row, c.clearfix)}>
          <div className={f(localClasses.mainSoftware, c.col12, c.smCol6, c.center, c.left, c.px3)}>
            <BorderStar style={{ width: '60%', margin: '0px auto 15px auto' }}>
              <img style={{ maxWidth: '80px', maxHeight: '60px' }} src={frameRippleImage} alt={'Frame.io'} />
            </BorderStar>
            <Text variant={'mediumness'}>{copy.homeView.infoSections.frame.heading}</Text>
            <Text variant={'pBold'} color={'pinkSlate'} style={{ marginBottom: '14px' }}>{copy.homeView.infoSections.frame.description}</Text>
            <a href={copy.homeView.infoSections.frame.url} target='_blank'>
              <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
            </a>
          </div>
          <div className={f(localClasses.mainSoftware, c.col12, c.smCol6, c.center, c.left, c.px3)}>
            <BorderStar style={{ width: '60%', margin: '0px auto 15px auto' }}>
              <img style={{ maxWidth: '80px', maxHeight: '60px' }} src={adobeRippleImage} alt={'Adobe'} />
            </BorderStar>
            <Text variant={'mediumness'}>{copy.homeView.infoSections.adobe.heading}</Text>
            <Text variant={'pBold'} color={'pinkSlate'} style={{ marginBottom: '14px' }}>{copy.homeView.infoSections.adobe.description}</Text>
            <a href={copy.homeView.infoSections.adobe.url} target='_blank'>
              <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
            </a>
          </div>
        </div>
      </div>
    </div>

    {/* Software Bundles */}
    <div className={f(c.row, c.clearfix)}>
      <div className={f(c.col11, c.mxAuto)}>
        <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
          <div className={f(localClasses.extraSummary)}>
            <img className={f(localClasses.extraImage, c.mb2)} src={musicbedImage} alt={'Musicbed'} />
            <Text variant={'pExtra'}>{copy.homeView.extraSections.musicbed.tag}</Text>
            <MoneyCounter countOpts={COUNTUP_OPTIONS} variant={'pBold'} price={copy.homeView.extraSections.musicbed.cost} />
          </div>
          <div className={f(localClasses.extraDetails)}>
            <Text variant={'pBook'} color={'pinkSlate'} style={{ marginBottom: '14px' }}>
              {copy.homeView.extraSections.musicbed.description}
            </Text>
            <a href={copy.homeView.extraSections.musicbed.url} target='_blank'>
              <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
            </a>
          </div>
        </div>

        <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
          <div className={f(localClasses.extraSummary)}>
            <img className={f(localClasses.extraImage, c.mb2)} src={videocopilotImage} alt={'Video Copilot'} />
            <Text variant={'pExtra'}>{copy.homeView.extraSections.videocopilot.tag}</Text>
            <MoneyCounter countOpts={COUNTUP_OPTIONS} variant={'pBold'} price={copy.homeView.extraSections.videocopilot.cost} />
          </div>
          <div className={f(localClasses.extraDetails)}>
            <Text variant={'pBook'} color={'pinkSlate'} style={{ marginBottom: '14px' }}>
              {copy.homeView.extraSections.videocopilot.description}
            </Text>
            <a href={copy.homeView.extraSections.videocopilot.url} target='_blank'>
              <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
            </a>
          </div>
        </div>

        <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
          <div className={f(localClasses.extraSummary)}>
            <img className={f(localClasses.extraImage, c.mb2)} src={redgiantImage} alt={'Red Giant'} />
            <Text variant={'pExtra'}>{copy.homeView.extraSections.redgiant.tag}</Text>
            <MoneyCounter countOpts={COUNTUP_OPTIONS} variant={'pBold'} price={copy.homeView.extraSections.redgiant.cost} />
          </div>
          <div className={f(localClasses.extraDetails)}>
            <Text variant={'pBook'} color={'pinkSlate'} style={{ marginBottom: '14px' }}>
              {copy.homeView.extraSections.redgiant.description}
            </Text>
            <a href={copy.homeView.extraSections.redgiant.url} target='_blank'>
              <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
            </a>
          </div>
        </div>

        <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
          <div className={f(localClasses.extraSummary)}>
            <img className={f(localClasses.extraImage, c.mb2)} src={borisfxImage} alt={'Boris FX'} />
            <Text variant={'pExtra'}>{copy.homeView.extraSections.borisfx.tag}</Text>
            <MoneyCounter countOpts={COUNTUP_OPTIONS} variant={'pBold'} price={copy.homeView.extraSections.borisfx.cost} />
          </div>
          <div className={f(localClasses.extraDetails)}>
            <Text variant={'pBook'} color={'pinkSlate'} style={{ marginBottom: '14px' }}>
              {copy.homeView.extraSections.borisfx.description}
            </Text>
            <a href={copy.homeView.extraSections.borisfx.url} target='_blank'>
              <Text variant={'pBold'} color={'byzantine'}>Learn More</Text>
            </a>
          </div>
        </div>
      </div>
    </div>

    {/* Final Beat */}
    <div className={f(c.clearfix, localClasses.finalBeat)}>
      <img className={localClasses.tubes1} src={tubes1} alt={'Tubes 1'} />
      <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
        <div className={f(c.col12, c.center, c.left, c.px5)}>
          <Text variant={'heavyHeadline'}>{copy.homeView.finalBeat.tag}</Text>
          <span className={f(c.inlineBlock)}>
            <Text variant={'massiveHeadline'} classes={c.inline}>{'$'}</Text>
            <MoneyCounter countOpts={COUNTUP_OPTIONS_NO_PREF} variant={'massiveHeadline'} price={copy.homeView.finalBeat.cost} classes={localClasses.massive} />
          </span>
          <Text variant={'subheadlineLarge'}>{copy.homeView.finalBeat.para}</Text>
        </div>
      </div>
      <img className={localClasses.tubes2} src={tubes2} alt={'Tubes 2'} />
    </div>

    {/* Footer */}
    <div className={f(c.clearfix, localClasses.footer)}>
      <div className={f(c.row, c.clearfix, localClasses.extraSection)}>
        <div className={f(c.col11, c.mdCol7, c.mxAuto, c.pb5, c.pt5)}>
          <EmailForm expand position={'footer'} />
        </div>
        <div className={f(c.col11, c.mdCol7, c.mxAuto, localClasses.footerEnd)}>
          <div className={localClasses.footerSet}><Text variant={'p'}>{'Frame.io, Inc.'}</Text></div>
          <div className={localClasses.footerSet}><Frame /></div>
          <div className={localClasses.footerSet}>
            <a href="https://www.facebook.com/frameioapp" target='_blank'>
              <img src={facebookIcon} style={{ marginRight: '14px' }} />
            </a>
            <a href="https://twitter.com/Frame_io" target='_blank'>
              <img src={twitterIcon} style={{ marginRight: '14px' }} />
            </a>
            <a href="https://dribbble.com/frameio" target='_blank'>
              <img src={dribbleIcon} />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);



// WEBPACK FOOTER //
// ./src/views/HomeView.js